import { render, staticRenderFns } from "./health-login.vue?vue&type=template&id=21c7e760&scoped=true"
import script from "./health-login.vue?vue&type=script&lang=js"
export * from "./health-login.vue?vue&type=script&lang=js"
import style0 from "./health-login.vue?vue&type=style&index=0&id=21c7e760&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7e760",
  null
  
)

export default component.exports